exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.layout.list-container.row.wrap {\n  margin-top: 24px;\n}\n", ""]);

